export default __webpack_public_path__ + "static/media/barcode_square.dbf89187.svg";